import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersAutoAdvanceOnAssign = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'chat_auto_advance_on_assign', true)
)
